import type { Grid } from './game'

export function rotateRowLeft(grid: Grid, row: number): Grid {
  const newGrid = grid.map(r => [...r])
  const r = newGrid[row]
  const first = r[0]
  for (let c = 0; c < 4; c++) r[c] = r[c + 1]
  r[4] = first
  return newGrid
}

export function rotateRowRight(grid: Grid, row: number): Grid {
  const newGrid = grid.map(r => [...r])
  const r = newGrid[row]
  const last = r[4]
  for (let c = 4; c > 0; c--) r[c] = r[c - 1]
  r[0] = last
  return newGrid
}

export function rotateColUp(grid: Grid, col: number): Grid {
  const newGrid = grid.map(r => [...r])
  const positions: number[] = []
  for (let r = 0; r < 5; r++) {
    if (newGrid[r][col] !== null) positions.push(r)
  }
  if (positions.length <= 1) return newGrid
  const first = newGrid[positions[0]][col]
  for (let i = 0; i < positions.length - 1; i++) {
    newGrid[positions[i]][col] = newGrid[positions[i + 1]][col]
  }
  newGrid[positions[positions.length - 1]][col] = first
  return newGrid
}

export function rotateColDown(grid: Grid, col: number): Grid {
  const newGrid = grid.map(r => [...r])
  const positions: number[] = []
  for (let r = 0; r < 5; r++) {
    if (newGrid[r][col] !== null) positions.push(r)
  }
  if (positions.length <= 1) return newGrid
  const last = newGrid[positions[positions.length - 1]][col]
  for (let i = positions.length - 1; i > 0; i--) {
    newGrid[positions[i]][col] = newGrid[positions[i - 1]][col]
  }
  newGrid[positions[0]][col] = last
  return newGrid
}

